import * as Yup from 'yup';

import { nameofFactory } from 'src/utils/nameofFactory';
import { DisputeAgreement, DisputeExpectedAmount } from 'src/utils/options';
import { ShapeOf } from 'src/utils/types';
import { IDisputeFormValues, IDisputeTableItem, OneOffOrRecurring } from './types';

const nameofForm = nameofFactory<IDisputeFormValues>();
const nameofRow = nameofFactory<IDisputeTableItem>();

export const validationSchema = Yup.object().shape({
  agreementType: Yup.string().required(),
  reason: Yup.string().required('You need to fill this field').label('This'),
  expectedAmount: Yup.string().when(nameofForm('agreementType'), {
    is: DisputeAgreement.AMEND_INVOICE_CREDIT_NOTE,
    then: (schema) => schema.default(DisputeExpectedAmount.LUMP_SUM),
    otherwise: (schema) => schema.nullable(),
  }),
  amountOption: Yup.string().when(nameofForm('agreementType'), {
    is: DisputeAgreement.ACCEPT_INVOICE_WITH_CREDIT_NOTE,
    then: (schema) => schema.required('You need to select an amount option'),
    otherwise: (schema) => schema.nullable(),
  }),
  otherAmount: Yup.string().when([nameofForm('agreementType'), nameofForm('amountOption')], {
    is: (agreementType: DisputeAgreement, amountOption: string) => {
      // For ACCEPT_INVOICE_WITH_CREDIT_NOTE, only require if amountOption is 'OTHER'
      return agreementType === DisputeAgreement.ACCEPT_INVOICE_WITH_CREDIT_NOTE && amountOption === 'OTHER';
    },
    then: (schema) => schema.required('You need to fill this field'),
    otherwise: (schema) => schema.nullable(),
  }),
  totalAmount: Yup.string().when([nameofForm('agreementType'), nameofForm('expectedAmount')], {
    is: (agreementType: DisputeAgreement, expectedAmount: DisputeExpectedAmount) => {
      // For legacy agreement types, use original logic
      const isTrue =
        agreementType === DisputeAgreement.COMMERCIAL_SETTLEMENT_CREDIT_NOTE ||
        agreementType === DisputeAgreement.ACCEPT_INVOICE ||
        (agreementType === DisputeAgreement.AMEND_INVOICE_CREDIT_NOTE && expectedAmount === DisputeExpectedAmount.LUMP_SUM);
      return isTrue;
    },
    then: (schema) => schema.required('You need to fill this field'),
    otherwise: (schema) => schema.nullable(),
  }),
  disputeTableItems: Yup.array().of(
    Yup.object().shape({
      validityPeriod: Yup.object().when([nameofRow('oneOffOrRecurring')], {
        is: (oneOffOrRecurring: OneOffOrRecurring) => oneOffOrRecurring === OneOffOrRecurring.Recurring,
        then: (schema) => schema.required().label('This'),
        otherwise: (schema) => schema.nullable(),
      }),
    } as ShapeOf<IDisputeTableItem>)
  ),
} as ShapeOf<IDisputeFormValues>);
